import type {UseCampaignBannerContext} from '@/modules/common/hooks/useCampaigns/types';

import {useContext} from 'react';

import {campaignBannerContext} from '@/modules/common/hooks/useCampaigns/contexts';

export const useCampaignBanner = (): UseCampaignBannerContext => {
  return useContext(campaignBannerContext);
};
